module.exports = __webpack_public_path__ + "static/media/TasklyTaskModel.c032ba65.png";